import * as React from 'react';
import { Button } from './Button';
import './FormActions.css';

interface FormActionsProps {
  submitLabel: string;
  onSubmit: () => void;
  submitDisabled?: boolean;
  /** 指定したときだけキャンセルボタンを出す */
  onCancel?: () => void;
  cancelLabel?: string;
}

/**
 * フォームの下に置く操作ボタンの行。区切り線の下に、入力欄と同じ左端から［送信］［キャンセル］の順に並べる。
 * 入力欄が左寄せのフォームでは、ボタンを右端に離して置くと入力欄から遠くなるため、左寄せにして主な操作を先に置く。
 * ボタンの大きさは、見出しの行の「新規作成」などの画面の主な操作と同じ大きさ（mini）にそろえる。
 */
export const FormActions: React.FC<FormActionsProps> = function (props) {
  return (
    <div className="FormActions">
      <Button
        type="button"
        color="normal"
        mini={true}
        disabled={props.submitDisabled}
        onClick={() => props.onSubmit()}
      >
        {props.submitLabel}
      </Button>
      {(() => {
        if (!props.onCancel) {
          return null;
        }
        const onCancel = props.onCancel;
        return (
          <Button type="button" color="white" mini={true} onClick={() => onCancel()}>
            {props.cancelLabel ?? 'キャンセル'}
          </Button>
        );
      })()}
    </div>
  );
};
